import React, { useRef, useState } from "react";
import { testIdProps } from "../../../../../utils/testIdProps";
import Styles from "../../Shared/sharedStyles.module.scss";
import InputField from "../../Shared/inputField/inputField";
import ErrorMessage from "../../../../../Shared/error-message/errorMessage";
import {
  buttonStyles,
  StyledButton,
} from "../../../../../Shared/button/button";
import { checkUAN } from "../../../../../utils/validation";

const errorObject = {
  uanNumberError: false,
  consentError: false,
};

const productName = "UAN Number";

const UANAdvancePopup = ({ handleResponse }: any) => {
  const uanNumberRef = useRef<any>("");
  const [isChecked, setIsChecked] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [error, setError] = useState({ ...errorObject });
  const [loading, setLoading] = useState(false);

  function isValid() {
    if (checkUAN(uanNumberRef?.current?.value)) {
      setError(errorObject);
      return setIsDisabled(false);
    }

    setError(() => ({
      ...error,
      uanNumberError: true,
    }));

    return setIsDisabled(true);
  }

  function handleCheck() {
    const uanNumber = uanNumberRef?.current?.value;
    const consent = isChecked === true ? "Y" : "N";

    if (!isChecked) {
      setError(() => ({
        ...error,
        consentError: true,
      }));
      return false;
    }

    setLoading(true);
    handleResponse({ uanNumber, consent }, setLoading);
  }

  return (
    <div className={`${Styles.content}`}>
      <div className={`${Styles.infoForm} pl-2`}>
        <hr />
        <p className="mt-2">Fill in the below details to run verification</p>
        <div className="d-flex flex-column">
          <div className="d-flex flex-column mb-4 ">
            <label className={`${Styles.label} flex-grow-1`}>
              {productName}
            </label>
            <InputField
              id="uan-advance-number"
              type="number"
              onChange={isValid}
              maxLength={12}
              inputRef={uanNumberRef}
              isError={error.uanNumberError}
              purpose="forPan"
            />
            {error.uanNumberError && (
              <ErrorMessage>{`Please enter a valid ${productName}`}</ErrorMessage>
            )}
          </div>
          <div className="pt-4 pl-4 pb-4 mt-4 d-flex flex-column">
            <div className="d-flex align-items-center py-0 gap-2">
              <input {...testIdProps("consent-checkbox-uan-advance")}
                type="checkbox"
                className={`${Styles.formCheckInput} `}
                onChange={(e: any) => setIsChecked(e.target.checked)}
              />
              <p className={`${Styles.ackText} mb-0`}>
                I hereby agree, to let zoop.one verify my data for verification
              </p>
            </div>
            {error.consentError && (
              <ErrorMessage>Please provide consent!</ErrorMessage>
            )}
          </div>
          <div className={`${Styles.buttonGroup}`}>
            <StyledButton
              id="id-submit-button-panNumber"
              hoverStyle={{ ...buttonStyles.primary.hover }}
              disabled={isDisabled}
              isLoading={loading}
              style={{ ...buttonStyles.primary.normal }}
              onClick={() => {
                setTimeout(() => setError({ ...errorObject }), 2000);
                handleCheck();
              }}
            >
              Run Verification
            </StyledButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UANAdvancePopup;
